import React, { Component, PropTypes } from 'react';
import idx from 'idx';
import partial from 'lodash/partial';
import { shareLink } from 'common/utils';
import DropdownMenu from 'common/components/dropdown_menu';

const ActionsMenu = ({
  onToggle, canComment, canTip, detailsUrl, toggleTip, entry, toggleOffer, canOffer,
  canViewCreative, canRemoveCreative, toggleRemoveCreative, canWithdraw, toggleDelete,
  canEliminate, toggleReinstate, canUnwithdraw, canUneliminate, toggleViolationModal,
  canReportViolation, canShare
}) => {
  const fullDetailsUrl = `${window.location.origin}${detailsUrl}`;
  const firstRevisionId = idx(entry, _ => _.revisions[0].id);
  const entryUrlSearch = firstRevisionId? `?revision=${firstRevisionId}` : '';

  const buttons = [{
    label: <span><i className="fa fa-fw fa-comment-o" /> Comments</span>,
    url: `${detailsUrl}comments/${entryUrlSearch}`,
    show: canComment
  }, {
    label: <span><i className="fa fa-fw fa-dollar" /> Tip creative</span>,
    action: partial(toggleTip, entry),
    show: canTip
  }, {
    label: <span><i className="fa fa-fw fa-handshake-o" /> Make offer</span>,
    action: partial(toggleOffer, entry),
    show: canOffer
  }, {
    url: `/users/${entry.author_username}/`,
    target: '_blank',
    label: <span><i className="fa fa-fw fa-user" /> View creative</span>,
    show: canViewCreative
  }, {
    label: <span><i className="fa fa-fw fa-user-times" /> Remove creative</span>,
    action: partial(toggleRemoveCreative, { id: entry.author, username: entry.author_username }),
    show: canRemoveCreative
  }, {
    label: <span><i className="fa fa-fw fa-times" /> Withdraw</span>,
    action: partial(toggleDelete, entry),
    show: canWithdraw
  }, {
    label: <span><i className="fa fa-fw fa-times" /> Eliminate</span>,
    action: partial(toggleDelete, entry),
    show: canEliminate
  }, {
    label: <span><i className="fa fa-fw fa-undo" /> Un-withdraw</span>,
    action: partial(toggleReinstate, entry),
    show: canUnwithdraw
  }, {
    label: <span><i className="fa fa-fw fa-undo" /> Un-eliminate</span>,
    action: partial(toggleReinstate, entry),
    show: canUneliminate
  }, {
    label: <span><i className="fa fa-fw fa-ban" /> Report violation</span>,
    action: partial(toggleViolationModal, { type: 'entry', id: entry.id, link: fullDetailsUrl }),
    show: canReportViolation
  }, {
    label: <span><i className="fa fa-fw fa-facebook" /> Share on Facebook</span>,
    action: partial(shareLink, fullDetailsUrl, 'facebook'),
    show: canShare
  }, {
    label: <span><i className="fa fa-fw fa-twitter" /> Tweet</span>,
    action: partial(shareLink, fullDetailsUrl, 'twitter'),
    show: canShare
  }];

  return <DropdownMenu buttons={buttons} className="tile-menu" onToggle={onToggle} />;
}

ActionsMenu.propTypes = {
  entry: PropTypes.object.isRequired,
  onToggle: PropTypes.func,
  canComment: PropTypes.bool.isRequired,
  canTip: PropTypes.bool.isRequired,
  canOffer: PropTypes.bool.isRequired,
  canViewCreative: PropTypes.bool.isRequired,
  canRemoveCreative: PropTypes.bool.isRequired,
  canWithdraw: PropTypes.bool.isRequired,
  canEliminate: PropTypes.bool.isRequired,
  canUnwithdraw: PropTypes.bool.isRequired,
  canUneliminate: PropTypes.bool.isRequired,
  canReportViolation: PropTypes.bool.isRequired,
  canShare: PropTypes.bool.isRequired,
  detailsUrl: PropTypes.string.isRequired,
  toggleTip: PropTypes.func.isRequired,
  toggleOffer: PropTypes.func.isRequired,
  toggleRemoveCreative: PropTypes.func.isRequired,
  toggleDelete: PropTypes.func.isRequired,
  toggleReinstate: PropTypes.func.isRequired,
  toggleViolationModal: PropTypes.func.isRequired,
};

export default ActionsMenu;



// WEBPACK FOOTER //
// ./entries/components/actions_menu.jsx